import { render, staticRenderFns } from "./Dialog_ShopCart.vue?vue&type=template&id=422a1ffd&scoped=true&"
import script from "./Dialog_ShopCart.vue?vue&type=script&lang=js&"
export * from "./Dialog_ShopCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a1ffd",
  null
  
)

export default component.exports